import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { BsGear } from "react-icons/bs";
import { SiNvidia } from "react-icons/si";
import FormatDateTime from "../../../../Functions/FormatDate";

const InfoModal = ({ show, handleClose, records }) => {

    const { t } = useLanguage();
    const closeModal = () => {
        handleClose();
    };

    return (
        <Modal show={show} onHide={closeModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label"><i className="fa-solid fa-info"></i> Cluster info</p>

                <div className="warning_delete_message">
                    <p>
                        A cluster is a set of nodes that run containerized applications managed by Erioon Kubernetes, providing automated deployment, scaling, and management of containerized workloads.
                    </p>
                    <p>Learn more in our <strong>documentation</strong>.</p>
                </div>
                <p className="review_cont_data">VM Size <span>{records.vm_size}</span></p>
                <p className="review_cont_data">Available nodes <span>{records.nodes}</span></p>
                <p className="review_cont_data">OS Type <span>{records.osType}</span></p>
                <p className="review_cont_data">Created at <span>{FormatDateTime(records.timestamp)}</span></p>
                <p className="review_cont_data">Status <span>
                    {records.status == "loading" ? (
                        <span className="title_status loading_cluster"><i className="fa-solid fa-rotate"></i> Loading</span>
                    ) : records.status == "running" ? (
                        <span className="title_status running_cluster"><i className="fa-solid fa-circle"></i> Running</span>
                    ) : records.status == "failed" ? (
                        <span className="title_status failed_cluster"><i className="fa-solid fa-circle"></i>Failed</span>
                    ) : records.status == "deleting" ? (
                        <span className="title_status failed_cluster"><i className="fa-solid fa-rotate"></i>Deleting</span>
                    ) : records.status == "updating" ? (
                        <span className="title_status running_cluster"><i className="fa-solid fa-rotate"></i>Updating</span>
                    ) : (
                        <span className="title_status loading_cluster"><i className="fa-solid fa-rotate"></i></span>
                    )}
                </span></p>
            </div>

            <div className="modal_footer">
                <div className="footer_btn_cont">
                    <button className="cancel_btn" onClick={closeModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default InfoModal;
